mtl.alloy.factory.earningsCalculator = (function($) {
    'use strict';

    var EARNING_PER_REPAIR = 75.25;


    /**
     * Return the earnings-calculator factory function.
     */
    return function(element, options) {

        var $element = $(element).first();
        element = $element[0];

        var $repairsPerDay = $element.find('input[name="repairs-per-day"]');
        var $daysPerMonth = $element.find('input[name="days-per-month"]');


        /**
         * Set the earnings result.
         */
        function setResult(val) {

            $element.find('.sparkle-box__body .value')
                .text(val)
                .trigger('change')
            ;

        }


        /**
         * Calculate the return the earnings value.
         */
        function calculate(repairsPerDay, daysPerMonth) {

            return Math.max(0, repairsPerDay * daysPerMonth * EARNING_PER_REPAIR) | 0;

        }


        /**
         * Update the result using the current state of the range sliders.
         */
        function updateResult() {

            var repairsPerDay = Math.round($repairsPerDay.val()) | 0;
            var daysPerMonth = Math.round($daysPerMonth.val()) | 0;

            setResult(
                calculate(repairsPerDay, daysPerMonth)
            );

        }


        /**
         * Sparkle!
         */
        function doSparkle() {

            var $sparkle = $element.find('.sparkle-box')
                .delay(33)
                .queue(function(next) {
                    $sparkle.addClass('do-sparkle');
                    next();
                })
                .delay(250)
                .queue(function(next) {
                    $sparkle.removeClass('do-sparkle');
                    next();
                })
            ;

        }


        // Bind range input listeners
        $repairsPerDay.add($daysPerMonth)
            .on('input change', updateResult)
        ;

        // Bind odometer listeners
        $element
            .on('odometerfinish', doSparkle)
        ;

        // Immediately update the result
        updateResult();

    };

}(jQuery));
